<template src="./html/Index.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	export default {
		props: ['user', 'isAuth', 'data', 'type'],
		data () {
			return {
				modal: {
					selector: 'modal-product-operations-' + Math.floor(Math.random() * 736456),
				},
				operation: {
					data: {
						operations: [],
						values: [0],
					},
				},
				operations: null,
				total: null,
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getOperations()
			},
			open() {
				if(this.data) {
					if(this.data.operations) {
						var data = Object.assign({}, this.data.operations.data)
						if(this.data.id) {
							var id = this.data.operations.id
						} else {
							var id = null
						}

						var value = this.data.value
						if(this.data.value) {
							if(this.data.product_attribute_type_field_id == 1) {
								if(this.data.value.decimal_value) {
									value = this.data.value.decimal_value
								}
							}
							if(this.data.product_attribute_type_field_id == 2) {
								if(this.data.value.integer_value) {
									value = this.data.value.integer_value
								}
							}
						}

						this.operation = {
							id: id,
							data: {
								operations: data.operations,
								values: data.values,
							}
						},
						this.total = value
					} else {
						this.clearData()
					}
				}
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			getOperations () {
				this.$http.get('admin/management/products/operation')
					.then(response => {
						this.operations = response.body
					})
			},
			addOperation (operation) {
				this.operation.data.values.push(0)
				this.operation.data.operations.push(operation.symbol)
				this.operate()
			},
			operate () {
				if(this.operation.data.values.length) {
					var key = 1
					for (var i = 0; i < this.operation.data.values.length; i++) {
						var value = this.operation.data.values[i]
						if(i == 0) {
							var val1 = value
							var val2 = Number(this.operation.data.values[i + 1])

							if(val2 != null) {
								var operator = this.operation.data.operations[i]
								if(operator) {
									this.total = eval(val1 + operator + val2)
								}
							}
						} else {
							var val2 = Number(this.operation.data.values[i + 1])

							if(val2 != null) {
								var operator = this.operation.data.operations[i]
								if(operator) {
									this.total = eval(this.total + operator + val2)
								}
							}
						}
					}
					this.total = parseFloat(this.total).toFixed(2)
				}
			},
			clearData () {
				this.operation.data.operations = []
				this.operation.data.values = [0]
				if(this.operation.id) {
					this.operation.id = null
				}
				this.total = null
			},
			validate() {
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						if(that.operation.id) {
							that.update()
						} else {
							that.store()
						}
					}
					return result
				})
			},
			update() {
				if(this.canStore) {
					if(this.data.id) {
						if(this.operation.id) {
							var api = 'admin/management/products/attribute/operations/' + this.operation.id
							if(this.type) {
								if(this.type == 'storage') {
									var api = 'admin/management/products/attribute/storage/operations/' + this.operation.id
								}
							}
							var loading = Ladda.create(this.$refs.btnUpdate)
							loading.start()
							this.operation.total = this.total
							this.$http.put(api, this.operation)
							.then(response => {
								var operation = response.body.data.operation
								var value = response.body.data.value
								this.data.operations = operation
								this.data.value = value
								loading.stop()
								this.close()
								this.$emit('operationsUpdated')
							}).catch(response => {
								loading.stop()
								console.log(response)
							})
						}
					}
				}
			},
			store() {
				if(this.canStore) {
					if(this.data.id) {
						if(!this.operation.id) {
							var api = 'admin/management/products/attribute/operations'
							this.operation.product_attribute_id = this.data.id
							if(this.type) {
								if(this.type == 'storage') {
									this.operation.product_attribute_storage_id = this.data.id
									var api = 'admin/management/products/attribute/storage/operations'
								}
							}
							var loading = Ladda.create(this.$refs.btnStore)
							loading.start()
							this.operation.total = this.total
							this.$http.post(api, this.operation)
							.then(response => {
								var operation = response.body.data.operation
								var value = response.body.data.value
								this.data.operations = operation
								this.data.value = value
								loading.stop()
								this.close()
								this.$emit('operationsUpdated')
							}).catch(response => {
								loading.stop()
								console.log(response)
							})
						}
					} else {
						if(this.total) {
							var value = this.total
						} else {
							var value = 1
						}
						var operations = Object.assign({}, this.operation)
						this.data.value = value
						this.data.operations = operations
						this.$emit('operationsUpdated')
						this.close()
					}
				}
			},
			canStore() {
				var can = true
				if(this.operation.data.operations.length == 0) {
					can = false
				}

				if(can) {
					if(this.errors.items.length) {
						can = false
					}
				}
				return can
			},
			destroy () {
				if(this.data.id) {
					if(this.operation.id) {
						var api = 'admin/management/products/attribute/operations/' + this.operation.id
						if(this.type) {
							if(this.type == 'storage') {
								var api = 'admin/management/products/attribute/storage/operations/' + this.operation.id
							}
						}
						var loading = Ladda.create(this.$refs.btnDestroy)
						loading.start()
						this.$http.delete(api, this.operation)
						.then(response => {
							var value = response.body.data.value
							this.data.value = value
							loading.stop()
							this.$delete(this.data, 'operations')
							this.clearData()
							this.close()
							this.$emit('operationsUpdated')
						}).catch(response => {
							loading.stop()
							console.log(response)
						})
					}
				} else {
					this.$set(this.data, 'operations', null)
					this.$set(this.data, 'value', 1)
					this.clearData()
					this.close()
					this.$emit('operationsUpdated')
				}
			},
		},
	}
</script>

<style>
	.modal {
		padding-left: 0px !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/management/operations/views/Index.vue